/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { ElementRef } from '@angular/core';
import { Rect } from './rect';

export class InViewInfo {
    public id: string;
    public inView: boolean = false;
    public changed: boolean = false;
    public element: ElementRef;
    public elementRect: Rect;
    public viewportRect: Rect;
    public directionVertical: number;
    public directionHorizontal: number;
}
